// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"styles_dataTableFormat__krVRc","formSpace":"styles_formSpace__6flR1"};